import React from 'react';
import ReportShell, { formatReportTimestamp } from '../../../shared/ReportShell';
import { AvailabilityPill } from '../../../shared/Pill';
import { SkipNotes, PriceLookupResultRow } from './priceLookupShared';

// Print/PDF capture of a Price Lookup run, for filing away and revisiting
// later (pat-architecture-reports-ui-standard.md's single-record contextual
// report shape — same "Report" card pattern as ProductReportView.js, no
// dropdown needed since there's only ever the one report for this screen).
// Renders the exact same PriceLookupResultRow/SkipNotes the live page does,
// so what gets printed can never drift from what was actually shown
// on-screen when the lookup ran — in the Ex GST / Inc GST view on screen
// too (viewInc), which the filter summary names.
function PriceLookupReportView({ result, product, customerScopeType, customerScopeLabel, productSearch, customerSearch, customerGroups, filterSummary, viewInc, onClose }) {
  const isEmpty = !result;

  return (
    <ReportShell
      title="Price Lookup Report"
      subtitle={(
        <>
          <div>{formatReportTimestamp()}</div>
          <div>Filtered by: {filterSummary}</div>
        </>
      )}
      onClose={onClose}
      printDisabled={isEmpty}
    >
      {isEmpty ? (
        <div style={{ padding: 24, textAlign: 'center', color: '#888' }}>Run a lookup first.</div>
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, fontSize: 16, fontWeight: 600 }}>
            <span>{product ? `${product.sku} — ${product.name}` : productSearch}</span>
            {product && <AvailabilityPill badge={product.availability_badge} date={product.availability_date} color={product.availability_badge_color} />}
          </div>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>Customer Scope: {customerScopeLabel}</div>

          <SkipNotes result={result} customerScopeType={customerScopeType} />

          {result.rows.map((row) => (
            <PriceLookupResultRow
              key={row.uomId}
              row={row}
              qty={result.qty}
              productSearch={productSearch}
              customerSearch={customerSearch}
              customerGroups={customerGroups}
              viewInc={viewInc}
              taxHandling={result.taxHandling || null}
            />
          ))}
        </>
      )}
    </ReportShell>
  );
}

export default PriceLookupReportView;
